import { observer } from "mobx-react";
import { ProjectStatus, projectStatusLabels } from "@/dbot/common/commonDomain";
import { Tag } from "@/components-v2/Tag";
import { useTranslation } from "@/stores/RootStoreContext";

export const ProjectStatusTag = observer(function ProjectStatusTag({
  status,
}: {
  status: ProjectStatus;
}) {
  const { t } = useTranslation();

  const label = t(projectStatusLabels[status]);
  return status === ProjectStatus.DRAFT ? (
    <Tag color="neutral" label={label} />
  ) : status === ProjectStatus.DOCUMENT_SIGNING_STARTED || status === ProjectStatus.SENT ? (
    <Tag color="info" label={label} />
  ) : status === ProjectStatus.FOLLOW_UP ? (
    <Tag color="info" label={label} />
  ) : status === ProjectStatus.COMPLETED ? (
    <Tag color="success" label={label} />
  ) : null;
});
